
    @if(isLoadFile){
      
    <button class="mt-3 btn btn-success mb-2" (click)="onLoadFile()" >Afficher liste des fichiers</button>
    }@else {
     <button class="mt-3 btn btn-success mb-2 me-2" (click)="onLoadFile()">Charger nouveau fichier</button>
     <button class="mt-3 btn btn-danger mb-2" (click)="onStopPayment()" >Arreter les paiements</button>
    
    }
    <div class="modal" tabindex="-1" role="dialog" id="loadFileResult" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body"><span
              class="{{this.messageColor}} text-center font-weight-bold">{{this.message}}</span></div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
          </div>
        </div>
      </div>
    </div>
    <div class="container d-flex justify-content-center align-items-center" id="addBillFile"
      *ngIf="isLoadFile&&!isDetails">
      <form class="text-center p-4 border rounded" style="width: 100%; max-width: 600px;" (ngSubmit)="onAddBillFile()"
        [formGroup]="billForm">
        <div class="mb-4 fw-bold">Charger le fichier des factures</div>
        <div class="form-group form-floating">
          <input type="hidden" formControlName="idPartner">
          <input type="file" class="ml-2 mr-2 mt-2 mb-2 form-control" #fileBill accept=".xlsx"
            (change)="onChangeFile($event)" placeholder="Ajouter le fichier des factures">
          <label class="mb-2">Ajouter le fichier des factures</label>
        </div>
        <button type="submit" class="btn btn-primary btn-block mt-3" [disabled]="!this.billForm.valid">Valider</button>
      </form>
    </div>
    <div id="listFile" *ngIf="!isLoadFile&&!isDetails" class="row">
      <table class="table table-bordered table-hover table-striped text-center">
        <thead class="table-success">
          <tr>
            <th>Nom Fichier</th>
            <th>Nombre d'enregistrements</th>
            <th>Date chargement</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          @for(billInfo of billInfos?.content | paginate:pageConfigInfo;track $index){
          <tr>
            <td>{{billInfo.fileName}}</td>
            <td>{{billInfo.nombre}}</td>
            <td>{{billInfo.createDay}}</td>
            <td>
              <div class="d-flex d-flex-row align-items-start justify-content-center">
                <button class="btn btn-success ml-auto mr-4 p-2" (click)="onDetailsFile(billInfo)">D&#233;tails</button>
              </div>
            </td>
          </tr>
          }
        </tbody>

      </table>
      <div class="d-flex justify-content-center">
    <pagination-controls previousLabel="Precedent" nextLabel="Suivant" (pageChange)="onNextPageFile($event)">
    </pagination-controls>
  </div>
    </div>
    <div id="detailsFile" *ngIf="isDetails">
      <table class="table table-bordered table-hover table-striped text-center">
        <thead class="table-success">
          <tr>
            <th>Montant</th>
            <th>Cod élève</th>
            <th>Nom élève</th>
            <th>Classe</th>
            <th>Date traitement</th>
            <th>status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let billInfo of bills|paginate:pageConfig">
            <td>{{billInfo.amount}}</td>
            <td>{{billInfo.idStudent}}</td>
            <td>{{billInfo.studentName}}</td>
            <td>{{billInfo.classe}}</td>
            <td>{{billInfo.modifiedAt}}</td>
            <td *ngIf="billInfo.status=='PAID'" class="bg-success round text-white">PAYE</td>
            <td *ngIf="billInfo.status=='CANCELED'" class="bg-danger round text-white">ANNULE</td>
            <td *ngIf="billInfo.status=='FAILED'" class="bg-danger round text-white">ECHOUE</td>
            <td *ngIf="billInfo.status=='PENDING'" class="bg-warning round text-white">En attente</td>

          </tr>

        </tbody>

      </table>
      <div class="d-flex justify-content-center">
      <pagination-controls previousLabel="Precedent" 
      nextLabel="Suivant" (pageChange)="loadNextBillPage($event)" 
      [directionLinks]="true" [responsive]="true" [autoHide]="true" [maxSize]="10">
      </pagination-controls>
    </div>